module.exports = __webpack_public_path__ + "static/img/strona_058.8593b54d.jpg";